import React from 'react';
import Wrapper from '../Wrapper';
import OverviewWidget from './components';

export function OverviewWidgetContainer(props) {
  return (
    <Wrapper {...props} useRedux={true}>
      <OverviewWidget {...props} />
    </Wrapper>
  );
}
